"use client"

import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        className: "astro-toast",
        classNames: {
          toast: "astro-toast-base",
          title: "astro-toast-title",
          description: "astro-toast-description",
          success: "astro-toast-success",
          error: "astro-toast-error",
          info: "astro-toast-info",
          warning: "astro-toast-warning",
        },
      }}
      style={
        {
          "--normal-bg": "oklch(0.1 0.03 260 / 0.4)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "oklch(1 0 0 / 0.05)",
          "--success-bg": "oklch(0.1 0.03 260 / 0.4)",
          "--success-text": "var(--popover-foreground)",
          "--success-border": "oklch(0.8 0.15 85 / 0.2)",
          "--error-bg": "oklch(0.1 0.03 260 / 0.4)",
          "--error-text": "var(--popover-foreground)",
          "--error-border": "oklch(0.5 0.2 20 / 0.2)",
          "--info-bg": "oklch(0.1 0.03 260 / 0.4)",
          "--info-text": "var(--popover-foreground)",
          "--info-border": "oklch(0.7 0.1 220 / 0.2)",
          "--warning-bg": "oklch(0.1 0.03 260 / 0.4)",
          "--warning-text": "var(--popover-foreground)",
          "--warning-border": "oklch(0.9 0.1 60 / 0.2)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
